'use client';

import { c as _c } from "react/compiler-runtime";
import { SdkProvider } from '@repo/sdk';
import { SessionHandler } from '@repo/sdk/auth';
import { PusherProvider } from '@repo/sdk/pusher';
import { UIProvider } from '@repo/ui';
import { SidebarProvider } from '@repo/ui/components';
export const Provider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <SdkProvider><UIProvider>{children}</UIProvider></SdkProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const AuthorizedProvider = t0 => {
  const $ = _c(6);
  const {
    children,
    session
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SessionHandler />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = session?.user?.access_token;
  let t3;
  if ($[1] !== children) {
    t3 = <SidebarProvider defaultOpen={true}>{children}</SidebarProvider>;
    $[1] = children;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <>{t1}<PusherProvider accessToken={t2}>{t3}</PusherProvider></>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};